import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocationsProvider } from '../locations/locations';
import { Observable } from 'rxjs';

declare var google: any;
@Injectable()
export class AddressLookupProvider {
  constructor(public http: HttpClient, private locations : LocationsProvider) {
  }

  createAutocomplete(addressEl: HTMLInputElement): Observable<any> {
    const autocomplete = new google.maps.places.Autocomplete(addressEl);
    return new Observable((sub: any) => {
      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) {
          sub.error({
            message: 'Autocomplete returned place with no geometry'
          });
        } else {
          sub.next(place.address_components);
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/address-lookup/address-lookup.ts